// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"xA-z","disabled":"yA-z","wrapper":"zA-z","mProduct":"AA-z","image":"BA-z","itemContainer":"CA-z","productName":"DA-z","itemDetails":"EA-z"};